<!--suppress ALL -->
<template>
	<v-select :items="options" v-model="model" :label="label" item-text="title" item-value="id"></v-select>
</template>

<script>
	import PackageModule from "src/store/modules/Package.module";
	import SelectMixin from "src/mixins/SelectMixin";

	export default {
		name: "packages-select",
		mixins: [new SelectMixin(PackageModule, "packages")],
		props: {value: {default: null},label:String},
		components: {}
	};
</script>
